export default __webpack_public_path__ + "static/media/search.de5ebb6c.svg";